import { useState } from 'react';
import { API_URL } from '@constants';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/cfg-system-settings/banner_promote_business';

export interface BannerPromoteBusiness {
    content_banner_promote_business_subtitle: string | null;
    content_banner_promote_business_title: string | null;
    content_banner_promote_business_description: string | null;
    content_banner_promote_business_button_text: string | null;
    content_banner_promote_business_link: string | null;
    content_banner_promote_business_image: string | null;
}

export interface GetBannerPromoteBusinessSuccessResponse {
    data: BannerPromoteBusiness;
    success: boolean;
    message: string;
}

export const useGetBannerPromoteBusiness = () => {
    const { getHeaders, getCommonParameters, handleCommonErrors } = useApiConfig();
    const [banner, setBanner] = useState<BannerPromoteBusiness | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const request = async () => {
        setLoading(true);
        setError(null);

        try {
            const inputParameters = new URLSearchParams(getCommonParameters()).toString();

            const response = await fetch(`${API_URL}${ENDPOINT_URL}?${inputParameters}`, {
                method: 'GET',
                headers: getHeaders(),
            });

            if (!response.ok) {
                const json = await response.json();
                const error = new Error(json.error || json.message || 'Erro ao buscar banner promote business') as ApiError;
                error.statusCode = response.status;
                throw error;
            }

            const result: GetBannerPromoteBusinessSuccessResponse = await response.json();

            setBanner(result.data);
        } catch (err: any) {
            handleCommonErrors(err);
            setError(err.message || 'Erro ao buscar banner promote business');
        } finally {
            setLoading(false);
        }
    };

    return { banner, request, loading, error };
};
